module.exports = __webpack_public_path__ + "static/media/compass.9fecbffd.png";